/* Events */
export const events = {
    keydown: 'keydown',
    input: 'input',
    moduleChanged: 'moduleChanged',
    inlineToolbarCreated: 'inlineToolbarCreated',
    inlineToolbarItemClick: 'inlineToolbarItemClick',
    inlineToolbarBeforeOpen: 'inlineToolbarBeforeOpen',
    formattingPerformed: 'formatting-performed',
    cut: 'cut',
    copy: 'copy',
    paste: 'paste',
    destroy: 'destroy',
    rtlChanged: 'rtl-changed',
    contentChanged: 'contentChanged',
    blockAdded: 'blockAdded',
    blockRemoved: 'blockRemoved',
    blockMoved: 'blockMoved',
    blockTransformed: 'blockTransformed',
    undoRedoPerformed: 'undoRedoPerformed',
    undoStackChanged: 'undoStackChanged',
    localeChanged: 'localeChanged',
    editorClick: 'editorClick',
    documentClick: 'documentClick'
};
/* Action Types */
export var actionType;
(function (actionType) {
    actionType["contentChanged"] = "contentChanged";
    actionType["formattingAction"] = "formattingAction";
    actionType["indent"] = "indent";
    actionType["checked"] = "checked";
    actionType["lineBreakAdded"] = "lineBreakAdded";
    actionType["isExpanded"] = "isExpanded";
    actionType["blockAdded"] = "blockAdded";
    actionType["blockRemoved"] = "blockRemoved";
    actionType["blockMoved"] = "blockMoved";
    actionType["multipleBlocksDeleted"] = "multipleBlocksDeleted";
    actionType["blockTransformed"] = "blockTransformed";
    actionType["multipleBlocksTransformed"] = "multipleBlocksTransformed";
    actionType["imageInsertion"] = "imageInsertion";
    actionType["clipboardPaste"] = "clipboardPaste";
    actionType["tableRowInserted"] = "tableRowInserted";
    actionType["tableRowDeleted"] = "tableRowDeleted";
    actionType["tableColumnInserted"] = "tableColumnInserted";
    actionType["tableColumnDeleted"] = "tableColumnDeleted";
    actionType["tableCellsCleared"] = "tableCellsCleared";
    actionType["tableCellsPasted"] = "tableCellsPasted";
    actionType["tableRowsDeleted"] = "tableRowsDeleted";
    actionType["tableColumnsDeleted"] = "tableColumnsDeleted";
    actionType["tableHeaderInput"] = "tableHeaderInput";
    actionType["tableColumnResized"] = "tableColumnResized";
})(actionType || (actionType = {}));
/* Commands */
export const ADDBLOCK = 'ADDBLOCK';
export const SPLITBLOCK = 'SPLITBLOCK';
export const DELETEBLOCK = 'DELETEBLOCK';
export const INDENTBLOCK = 'INDENTBLOCK';
export const DELETEATCURSOR = 'DELETEATCURSOR';
export const MOVEBLOCK = 'MOVEBLOCK';
export const DUPLICATEBLOCK = 'DUPLICATEBLOCK';
export const FORMATTINGACTION = 'FORMATTINGACTION';
export const CLEAREVENTCHANGES = 'CLEAREVENTCHANGES';
export const DELETE_NON_MERGABLEBLOCK = 'DELETE_NON_MERGABLEBLOCK';
/* Constant string values */
export const RTL_CLS = 'e-rtl';
export const DISABLED_CLS = 'e-disabled';
export const HIDDEN_CLS = 'e-hidden';
export const SPACE = ' ';
export const BLOCK_CONTAINER_ID = '_blockcontainer';
export const BLOCK_CONTAINER_CLS = 'e-block-container';
export const BLOCK_ID_PREFIX = 'block';
export const CONTENT_ID_PREFIX = 'content';
export const INDENT_KEY = '--block-indent';
export const BLOCK_CLS = 'e-block';
export const CONTENT_CLS = 'e-block-content';
export const CALLOUT_BLOCK_CLS = 'e-callout-block';
export const QUOTE_BLOCK_CLS = 'e-quote-block';
export const TOGGLE_BLOCK_CLS = 'e-toggle-block';
export const CALLOUT_CONTENT_CLS = 'e-callout-content';
export const QUOTE_CONTENT_CLS = 'e-quote-content';
export const TOGGLE_CONTENT_CLS = 'e-toggle-content';
export const TABLE_BLOCK_CLS = 'e-table-block';
export const TABLE_CELL_BLK_CONTAINER = 'e-cell-blocks-container';
export const TABLE_CELL_FOCUS = 'e-cell-focus';
export const TABLE_COL_MIN_WIDTH = 60;
export const TABLE_NEW_COL_WIDTH = 120;
export const BLOCKACTION_MENUBAR_ID = '_blockaction-menubar';
export const BLOCKACTION_POPUP_ID = '_blockaction-popup';
export const BLOCKACTION_TOOLTIP_ID = '_blockaction-tooltip';
export const BLOCKEDITOR_CONTEXTMENU_ID = '_contextmenu';
export const BLOCKEDITOR_INLINETBAR_ID = '_inline-toolbar';
export const INLINE_TBAR_POPUP_ID = '_inline-toolbar-popup';
export const INLINE_TBAR_TOOLTIP_ID = '_inline-toolbar-tooltip';
export const LINKDIALOG_ID = '_linkDialog';
export const BLOCKACTION_MENUBAR_CLS = 'e-blockeditor-blockaction-menubar';
export const BLOCKACTION_POPUP_CLS = 'e-blockeditor-blockaction-popup';
export const BLOCKACTION_TOOLTIP_CLS = 'e-blockeditor-blockaction-tooltip';
export const BLOCKEDITOR_CONTEXTMENU_CLS = 'e-blockeditor-contextmenu';
export const BLOCKEDITOR_INLINETBAR_CLS = 'e-blockeditor-inline-toolbar';
export const INLINE_TBAR_POPUP_CLS = 'e-blockeditor-inline-toolbar-popup';
export const INLINE_TBAR_TOOLTIP_CLS = 'e-blockeditor-inline-toolbar-tooltip';
export const LINKDIALOG_CLS = 'e-blockeditor-link-dialog';
export const TBAR_ITEM_CLS = 'e-toolbar-item';
